import axiosWrapper, { baseUrl } from './core';

const BASE_URL = '/api/orders';

export const getPlanning = () =>
  axiosWrapper.get(`${baseUrl}${BASE_URL}/get-planning`);
